import { render } from "./FinalExamRuleView.vue?vue&type=template&id=7b103751"
import script from "./FinalExamRuleView.vue?vue&type=script&lang=js"
export * from "./FinalExamRuleView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\police-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__